<template>
    <div>
        <CardShell>
            <DisplayToolCore :tool="listing" :route="'/search' + (query ? '?q=' + query : '') " linkText="Search Results"/>
        </CardShell>
    </div>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import DisplayToolCore from '@/components/global/displayToolCore/DisplayToolCore.vue';
import { mapState } from 'vuex';

export default {
    components: {
        CardShell,
        DisplayToolCore
    },
    computed: {
        ...mapState('listingDetail', ['listing']),
        ...mapState('listings', ['query']),
        xs() {
            return this.$mq === 'xs';
        }
    }
};
</script>
